
<!--
Created by CHT 2020/7/30 8:56
1、编辑器、展示器

// 使用前需要设置
 CodeMirror 函数 列表
 CodeMirror.keywords = keywords

 CodeMirror 变量配置
 CodeMirror.fields = {}

-->
<template>
  <div class="formula-editor">
    <div ref="mergeView" v-if="view"></div>
    <textarea
      @change="textChange"
      :placeholder="placeholder"
      ref="codemirror"
      v-else>
    </textarea>
  </div>
</template>

<script>

  export default {
    name: "FormulaEditor",
    props: {
      value: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: '每行输入一个单号，最多只允许提交20个字号'
      },
      options: {
        type: Object,
        default: () => ({})
      },
      view: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        msg: '',
        myCm: '',
        codemirror: null,
        cmInstance: null,
        globalOptions: {
          mode: 'text/x-formula',          //定义mode
          theme: "formula",                  //选中的theme
          matchBrackets: true, // 是否添加匹配括号高亮
          autoCloseBrackets: true,
          lineWrapping: true,
          autofocus:true,
        }
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      // 初始化
      init() {
        const cmOptions = Object.assign({}, this.options, this.globalOptions)
        if (this.view) {
          this.codemirror = CodeMirror.MergeView(this.$refs.mergeView, cmOptions)
          this.cmInstance = this.codemirror.edit
        } else {
          this.codemirror = CodeMirror.fromTextArea(this.$refs.codemirror, cmOptions)
          this.cmInstance = this.codemirror
          this.cmInstance.setValue(this.value)
          this.codemirror.on("inputRead", function (e, t) {
            if (
              !e.state.completionActive &&
              "+input" === t.origin &&
              1 === t.text.length &&
              /^[a-zA-Z]+$/.test(t.text[0])
            ) {
              CodeMirror.commands.autocomplete(e, null, {
                completeSingle: false
              })
            }
          })
          this.codemirror.on("change",  (instance, changeObj)=> {
            this.$emit('update:value', this.getValue())
            this.$emit('textChange', changeObj)
          })
        }
        this.$emit('ready')
      },

      // 返回值
      getValue() {
        return this.codemirror ? this.codemirror.getValue() : null
      },

      // 设置值
      setValue(val) {
        if (this.cmInstance) {
          return this.cmInstance.setValue(val)
        }
      },
      textChange() {
        // console.log(arguments)
      }
    }
  }
</script>

<style lang="less">
  .formula-editor {
    line-height: 1.5;
  }
</style>
